export default __webpack_public_path__ + "static/media/boxbg.fa885200.jpeg";